import { Button, Drawer } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { memo } from 'react';
import GenericSelectFilter from './items/GenericSelectFilter';
import SelectFilter from '../ui/filters/items/GenericSelectFilter';

const WarehouseFilterDrawer = ({ open, setOpen, isLoading = false }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleResetFiler = () => {
    navigate(location.pathname, { replace: true });
  };

  return (
    <Drawer
      anchor='left'
      open={open}
      onClose={() => setOpen(false)}
      PaperProps={{
        sx: { padding: '18px', background: 'transparent', boxShadow: 'none' },
      }}
    >
      <div className='dashboard-filter-drawer-wrapper !pt-2 first-letter bg-white h-full rounded-lg border border-[#E5E9EB]'>
        <div className='mb-3 text-end flex justify-between items-center border-b'>
          <div className='text-[16px] leading-[16px] font-semibold'>Filter</div>
          <Button
            color='error'
            // variant='outlined'
            className='!-mr-[5px]'
            size='small'
            disabled={isLoading}
            onClick={() => handleResetFiler()}
          >
            Tozalash
          </Button>
        </div>
        <GenericSelectFilter
          query='staff_id'
          path='/dictionary/staffs'
          label="Mas'ul hodim"
        />
        <SelectFilter
          query='status'
          label='Status'
          options={[
            { name: 'Aktiv', id: '1' },
            { name: 'Inaktiv', id: '0' },
          ]}
        />
      </div>
    </Drawer>
  );
};
export default memo(WarehouseFilterDrawer);
